import inputDefaultDark from '../../../../common/algorithms/input-default-dark';

const condition = (ratio) => ratio >= 1.7;

const dark = (params) => inputDefaultDark(params, { condition });

export default dark;
